// extracted by mini-css-extract-plugin
export var shake = "_l-1";
export var toastCloseButton = "_l-0";